import { ReactNode } from 'react';
import { CoreBox, CoreTypography } from '@youscience/core';
import { Container } from '@components/Layout/components/Container';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { BreadcrumbsLinks } from '@interfaces/location';
import { StyledNavBar, StyledHeader, StyledContainer, StyledContent, sxStyles } from './ListHeader.styles';

interface ListHeaderProps {
  title: string;
  description: string;
  breadcrumbs: {
    links: BreadcrumbsLinks[];
    currentPage: string;
  };
  actions?: ReactNode;
  switcherComponent?: ReactNode;
}

export const ListHeader = ({ title, description, breadcrumbs, actions, switcherComponent }: ListHeaderProps) => (
  <StyledHeader>
    <StyledContainer>
      <Breadcrumbs links={breadcrumbs.links} currentPage={breadcrumbs.currentPage} />
      <StyledNavBar>
        <StyledContent>
          <CoreTypography variant="h2" component="h1" data-testid="navBarTitle">
            {title}
          </CoreTypography>
          <CoreTypography variant="body1">{description}</CoreTypography>
        </StyledContent>
        {switcherComponent}
      </StyledNavBar>
      {actions && (
        <CoreBox sx={sxStyles.actionsWrapper}>
          <CoreBox>{actions}</CoreBox>
        </CoreBox>
      )}
    </StyledContainer>
  </StyledHeader>
);
